<template>
  <main class="onboarding tw-min-h-screen tw-bg-[#FAFBFF]">
    <!-- Header -->
    <header class="tw-w-full tw-border-b tw-border-[#F0F4FD] tw-bg-white">
      <div class="tw-max-w-[1280px] tw-mx-auto tw-px-6 md:tw-px-12 tw-h-16 tw-flex tw-items-center tw-justify-between">
        <a
          href="http://getequity.io"
          target="_blank"
          rel="noopener noreferrer"
          class="tw-flex tw-items-center"
        >
          <img
            src="https://res.cloudinary.com/djalafcj9/image/upload/v1654256869/getequityV2/GetEquity_Logo_1_w9teqh.svg"
            alt="GetEquity Logo"
            class="tw-h-8"
          />
        </a>
        
        <Popper v-if="!organisationDetails?.email && $route.name !== 'SignIn'" offsetDistance="8" placement="bottom-end">
          <button class="header-btn header-btn--outline">
            <span>Sign In</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <template #content>
            <div class="dropdown-menu">
              <a
                :href="windowLocation.origin.includes('getequity.io')
                  ? 'https://app.getequity.io/onboarding/signin'
                  : 'https://staging--getequityinvestors.netlify.app/onboarding/signin'"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
              >
                <span class="dropdown-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 10C12.0711 10 13.75 8.32107 13.75 6.25C13.75 4.17893 12.0711 2.5 10 2.5C7.92893 2.5 6.25 4.17893 6.25 6.25C6.25 8.32107 7.92893 10 10 10Z" stroke="#4D84FF" stroke-width="1.5"/>
                    <path d="M3.75 17.5C3.75 14.0482 6.54822 11.25 10 11.25C13.4518 11.25 16.25 14.0482 16.25 17.5" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </span>
                Sign in as an Investor
              </a>
              <a
                :href="windowLocation.origin.includes('getequity.io')
                  ? 'https://founders.getequity.io/onboarding/account-type'
                  : 'https://staging--company-dealroom.netlify.app/onboarding/account-type'"
                target="_blank"
                class="dropdown-item"
              >
                <span class="dropdown-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5 6.25V13.75C17.5 16.25 16.25 17.5 13.75 17.5H6.25C3.75 17.5 2.5 16.25 2.5 13.75V6.25C2.5 3.75 3.75 2.5 6.25 2.5H13.75C16.25 2.5 17.5 3.75 17.5 6.25Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.5 5H7.5C6.25 5 5.625 5.625 5.625 6.875V8.125H14.375V6.875C14.375 5.625 13.75 5 12.5 5Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
                Sign in as a Business
              </a>
              <router-link
                :to="{ name: 'SignIn' }"
                class="dropdown-item"
              >
                <span class="dropdown-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 18.3334H12.5C16.6667 18.3334 18.3333 16.6667 18.3333 12.5V7.50002C18.3333 3.33335 16.6667 1.66669 12.5 1.66669H7.5C3.33333 1.66669 1.66666 3.33335 1.66666 7.50002V12.5C1.66666 16.6667 3.33333 18.3334 7.5 18.3334Z" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.125 10H6.875" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 13.125V6.875" stroke="#4D84FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
                Sign up as a Fund Manager
              </router-link>
            </div>
          </template>
        </Popper>

        <router-link
          v-if="$route.name === 'SignIn'"
          :to="{ name: 'DataCollection' }"
          class="header-btn header-btn--primary"
        >
          Sign up
        </router-link>
      </div>
    </header>
    
    <!-- Content -->
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-py-12 md:tw-py-16">
      <router-view v-slot="{ Component }">
        <transition name="fade-transform" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import { getItem } from "@/utils/storage.js";
import Popper from "vue3-popper";

export default {
  name: "OnboardingView",
  components: {
    Popper
  }, 
  computed: {
    ...mapGetters("organisationModule", ["organisationDetails"]),
    organisationDetails() {
      return getItem("org_details");
    },
    windowLocation() {
      return window.location;
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding {
  @include fadeIn;
  font-family: 'Circular Std', sans-serif;
}

.header-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;

  &--primary {
    background-color: #4D84FF;
    color: white;
    border: none;

    &:hover {
      background-color: #001E70;
    }
  }

  &--outline {
    background-color: white;
    color: #001140;
    border: 1px solid #F0F4FD;

    &:hover {
      border-color: #4D84FF;
      color: #4D84FF;
    }
  }
}

.dropdown-menu {
  background: white;
  border: 1px solid #F0F4FD;
  border-radius: 12px;
  padding: 8px;
  min-width: 240px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #001140;
  text-decoration: none;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #F7F9FD;
  }
}

.dropdown-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: #F0F4FD;
}
</style>
